export default __webpack_public_path__ + "static/media/colors-111.be33487f.png";